import { retryFetch } from '@cash-web/shared-util-fetch'

import { SQUARE_PCI_MERCHANT_VALIDATION } from '../constants'

export async function fetchMerchantSession(): Promise<string> {
  const merchantSessionResponse = await retryFetch(SQUARE_PCI_MERCHANT_VALIDATION.APPLE_PAY_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      client_id: SQUARE_PCI_MERCHANT_VALIDATION.CLIENT_ID,
      location_id: SQUARE_PCI_MERCHANT_VALIDATION.LOCATION_ID,
      validation_url: `${window.location.origin}${window.location.pathname}`,
      merchant_name: SQUARE_PCI_MERCHANT_VALIDATION.MERCHANT_NAME,
    }),
  })

  const merchantSessionJson = await merchantSessionResponse.json()
  return JSON.parse(merchantSessionJson.session)
}
